import { Typography, message, Input, Row, Col, Card } from "antd";
import { TeamOutlined } from "@ant-design/icons";
import { useState, useEffect } from "react";
import PersonasIndex from "./PersonasIndex"; // Adjust the import path as needed
import axios from "axios";
import { useAuth } from "../../layout/auth";

export default function Persons() {
  const [personas, setPersonas] = useState([]);
  const [search, setSearch] = useState("");
  const [filteredPersonas, setFilteredPersonas] = useState([]);
  const [loading, setLoading] = useState(false);

  const auth = useAuth(); // Assuming you still want to use auth for fetching data

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/personas`) // Adjust the endpoint as needed
      .then((res) => {
        setPersonas(res.data);
        setFilteredPersonas(res.data); // Initialize filtered personas
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        message.error(err.message);
      });
  }, []);

  useEffect(() => {
    if (search) {
      const filtered = personas.filter((persona) => {
        return (
          persona?.NombreCompleto?.toLowerCase().includes(search.toLowerCase()) ||
          persona?.TipoPersona?.toLowerCase().includes(search.toLowerCase()) ||
          persona?.Nacionalidad?.toLowerCase().includes(search.toLowerCase())
        );
      });
      setFilteredPersonas(filtered);
    } else {
      setFilteredPersonas(personas);
    }
  }, [search, personas]);

  return (
    <div>
      <Card style={{ borderRadius: "12px", boxShadow: "0 4px 12px rgba(0,0,0,0.08)", marginBottom: "20px" }} bodyStyle={{ padding: "24px" }}>
        <Typography.Title level={3} style={{ margin: 0, color: "#1890ff" }}>
          <TeamOutlined style={{ marginRight: "12px" }} />
          Personas en la base de datos
        </Typography.Title>
        <Row gutter={[16, 16]} style={{ marginBottom: "16px" }}>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <Input.Search
              placeholder="Buscar personas"
              onSearch={(value) => setSearch(value)}
              enterButton="Buscar"
              loading={loading}
            />
          </Col>
        </Row>
      </Card>
      <Card style={{ borderRadius: "12px", boxShadow: "0 4px 12px rgba(0,0,0,0.08)" }} bodyStyle={{ padding: "24px" }}>
        <PersonasIndex personas={filteredPersonas} loading={loading} />
      </Card>
    </div>
  );
}
